import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface ISingleBillInfoFormSlice {
  isDisplayingCard: boolean;
  canDisplayCard: boolean;
  isDirty: boolean;
  isLoading: boolean;
}

export const createSingleBillInfoFormSliceDefaultValues = (): ISingleBillInfoFormSlice => ({
  isDisplayingCard: true,
  canDisplayCard: true,
  isDirty: false,
  isLoading: false,
});

export const createSingleBillInfoFormSlice: StateCreator<ISingleBillInfoFormSlice> = () =>
  createSingleBillInfoFormSliceDefaultValues();

export type SingleBillInfoFormPageStore = UseBoundStore<StoreApi<ISingleBillInfoFormSlice>>;

type SingleBillInfoFormHooksStore = ISingleBillInfoFormSlice & {
  selectedBillingCountry: string | null;
  selectedBillingCurrency: string | null;
};

export const createSingleBillInfoFormHooks = <TStore extends SingleBillInfoFormHooksStore>(
  pageStore: UseBoundStore<StoreApi<TStore>>
) => ({
  useIsDisplayingCard: () => pageStore((state) => state.isDisplayingCard),
  useCanDisplayCard: () => pageStore((state) => state.canDisplayCard),
  useIsLoading: () => pageStore((state) => state.isLoading),
  useSelectedBillingCountry: () => pageStore((state) => state.selectedBillingCountry),
  useSelectedBillingCurrency: () => pageStore((state) => state.selectedBillingCurrency),
});

export type SingleBillInfoFormHooks = ReturnType<typeof createSingleBillInfoFormHooks>;
